import validate from "jquery-validation"
import * as Ladda from "ladda"
import "ladda/dist/ladda-themeless.min.css"

import "sharer.js"
import copy from "copy-to-clipboard"

import { load } from "recaptcha-v3"
import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'
import 'air-datepicker/air-datepicker.css'

import * as FilePond from "filepond"
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size"
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type"
import "filepond/dist/filepond.min.css"

FilePond.registerPlugin(FilePondPluginFileValidateSize)
FilePond.registerPlugin(FilePondPluginFileValidateType)


const VALID_CLASS = ""
const INVALID_CLASS = "is-invalid"
const VALID_ROW_CLASS = "fv-plugins-bootstrap5-row-valid"
const INVALID_ROW_CLASS = "fv-plugins-bootstrap5-row-invalid"
const ROW_PATTERN = /^(.*)(col|offset)(-(sm|md|lg|xl))*-[0-9]+(.*)$/


const isSelect2 = (el) => $(el).hasClass("select2")
const isSelectPicker = (el) => $(el).hasClass("selectpicker")
const inInputGroup = (el) => $(el).parent().hasClass("input-group")
const isFormCheck = (el) => $(el).parent().parent().hasClass("form-check")
const isCKEditor = (el) => $(el).hasClass("ckeditor")
const closestRow = (el) => $(el).parents().filter(function () {
    return this.classList.toString().match(ROW_PATTERN)
})
const isFlatPickr = (el) => $(el).hasClass("flatpickr-input")

//
// ─── CUSTOM VALIDATION OPTIONS ──────────────────────────────────────────────────
//
export var validationOptions = {
    errorClass: INVALID_CLASS,
    validClass: VALID_CLASS,
    ignore: ".ck",
    focusInvalid: true,
    errorElement: "div",
    //debug: true,

    highlight: function (element, errorClass, validClass) {

        //Add invalid classes to closest rows
        $(element).parent().addClass("has-validation")
        const row = closestRow(element)
        if (row) {
            $(row).removeClass(VALID_ROW_CLASS)
            $(row).addClass(INVALID_ROW_CLASS)
        }

        if (isFlatPickr(element)) {
            element = $(element).next("input.flatpickr-input.input")
        }

        $(element).removeClass(VALID_CLASS)
        $(element).addClass(INVALID_CLASS)
    },

    unhighlight: function (element, errorClass, validClass) {

        //Add valid classes to closest rows
        $(element).parent().removeClass("has-validation")
        const row = closestRow(element)
        if (row) {
            $(row).removeClass(INVALID_ROW_CLASS)
            $(row).addClass(VALID_ROW_CLASS)
        }

        if (isFlatPickr(element)) {
            element = $(element).next("input.flatpickr-input.input")
        }

        $(element).removeClass(INVALID_CLASS)
        $(element).addClass(VALID_CLASS)

    },

    errorPlacement(error, element) {

        if (inInputGroup(element)) element = $(element).parent()

        if (isSelect2(element)) element = $(element).next(".select2-container")

        if (isCKEditor(element)) element = $(element).next(".ck")

        if (isFlatPickr(element)) element = $(element).next("input.flatpickr-input.input")

        error.addClass("invalid-feedback")
        error.insertAfter(element)
    },

    invalidHandler: function (event, validator) {
        event.preventDefault()

        //If Ladda exists, stop all instances
        if (typeof Ladda !== "undefined") Ladda.stopAll();

        return false
    }
}

//
// ─── INITIALISE LADDA BUTTONS ───────────────────────────────────────────────────
Array.from(document.getElementsByClassName("ladda-button")).forEach(el =>
    el.dataset.style = "zoom-in"
)
window.Ladda = Ladda //Allows other scripts to access global Ladda object
Ladda.bind(".ladda-button")


//This must be re-run when a new form is created via JS.
$(".validate-form").each(function () {
    prepareFormValidation($(this))
});

function prepareFormValidation(form) {
    $(form).validate(validationOptions);
}

document.querySelectorAll('[data-copy-to-clipboard]').forEach(btn => {
    btn.addEventListener('click', () => {
        const url = btn.getAttribute('data-url');
        copy(url)
        alert("This web address was copied to your clipboard")
    });
});


if ($("#job-app-form").length) {

    let currentUploads = 0

    //Init submit button
    const btn = Ladda.create(document.querySelector('#submit-career-btn'));

    //Attach hidden jobId when modal is loaded
    document.addEventListener("DOMContentLoaded", function () {
        const applicationModal = document.getElementById("applicationModal")

        applicationModal.addEventListener("show.bs.modal", (event) => {
            const initBtn = event.relatedTarget
            const jobId = initBtn.getAttribute("data-job-id")

            const jobIdInput = document.getElementById("job_id")
            jobIdInput.value = jobId
        })
    })


    const blockSubmitBtn = (block) => {
        currentUploads += block ? 1 : -1
        currentUploads === 0 ? btn.stop() : btn.start()

        console.log(currentUploads)
    }

    const fileResume = FilePond.create(document.querySelector("input[id='file-resume'"), {
        allowMultiple: false,
        maxFiles: 1,
        server: {
            url: "/ajax/file-upload.php",
        },
        name: "fileUpload",
        credits: false,
        allowFileSizeValidation: true,
        maxFileSize: "10MB",
        chunkForce: true,
        chunkUploads: true,
        chunkSize: 5 * 1000 * 1000,
        labelIdle: "<p>Upload Your Resumé</p><p><small>Upload one of the following<br />formats: .pdf, .doc, .docx, .odt or .rtf</small></p><span class=\"filepond--label-action btn btn-blue-reverse\">Import</span>",
        allowFileTypeValidation: true,
        acceptedFileTypes: [
            //pdf
            "application/pdf",
            //dox
            "application/msword",
            //docx
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            //odt
            "application/vnd.oasis.opendocument.text",
            //rtf
            "application/rtf",
            //png
            "image/png",
        ]
    })

    const filePortfolio = document.querySelector("input[id='file-portfolio'")
    FilePond.create(filePortfolio, {
        allowMultiple: false,
        maxFiles: 1,
        server: {
            url: "/ajax/file-upload.php",
        },
        name: "fileUpload",
        credits: false,
        allowFileSizeValidation: true,
        maxFileSize: "10MB",
        chunkForce: true,
        chunkUploads: true,
        chunkSize: 5 * 1000 * 1000,
        labelIdle: "<p>Upload Your portfolio</p><p><small>Upload one of the following<br />formats: .pdf, .doc, .docx, .odt or .rtf</small></p><span class=\"filepond--label-action btn btn-blue-reverse\">Import</span>",
        allowFileTypeValidation: true,
        acceptedFileTypes: [
            //pdf
            "application/pdf",
            //dox
            "application/msword",
            //docx
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            //odt
            "application/vnd.oasis.opendocument.text",
            //rtf
            "application/rtf",
            //png
            "image/png",
        ]
    })


    document.addEventListener("FilePond:processfilestart", function () {
        blockSubmitBtn(true)
    });
    document.addEventListener("FilePond:processfile", function () {
        blockSubmitBtn(false)
    });


}


if ($("#mailing-list-form").length) {


    //Init submit button
    const btn = Ladda.create(document.querySelector("#mailing-list-form button[type='submit']"));

    const $form = $("#mailing-list-form")
    $form.on("submit", async function (e) {
        e.preventDefault()

        //Validate form
        $form.validate()

        const formData = new FormData($form[0]);
        const urlEncodedData = new URLSearchParams(formData);

        const showSuccess = () => {
            $form.hide()
            $("#mailing-list-form-success").show()
        }


        //If valid, submit
        if ($form.valid()) {
            try {
                const response = await fetch("/ajax/mailing-signup", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: urlEncodedData.toString()
                })

                if (response.ok) {
                    const result = await response.json()
                    if (result.status === true) {
                        //Success
                        showSuccess()
                    } else {
                        //Failure
                        alert("An error occurred while signing up. Please try again later")
                    }

                } else {
                    //Response is bad
                    alert("An error occurred while signing up. Please try again later")
                }

            } catch (e) {
                //JS error
                alert("An error occurred while signing up. Please try again later")
            }
        }

    })

}

//Captcha forms
if ($(".captcha-form").length > 0) {

    //Public site key from Google must be injected here:
    const captchaSystem = load("6LcAG5MrAAAAAJiuU65nAmRR1c8D4WYITEPB9NEe")

    $(".captcha-form").on("submit", function (e) {
        e.preventDefault()
        const $form = $(this)

        //Standard form validation
        prepareFormValidation($form)
        if (!$form.valid()) return

        const action = $form.data("captcha-action")
        const l = Ladda.create($form.find("button[type='submit']")[0])
        _blockForm(l, $form)


        captchaSystem.then((recaptcha) => {
            recaptcha.execute(action).then(token => {
                $form.find("input[name='captcha_response']")[0].value = token
                e.target.submit()
            })
        })
    })

    const _blockForm = function (btn, $form) {
        btn.start()
        $form.find("input,textarea,submit,button,a").attr("readonly", true)
    }
}

//Date picker
if ($(".air-date").length > 0) {

    new AirDatepicker(".air-date", {
        locale: localeEn,
        autoClose: true,
        dateFormat: "dd/MM/yyyy",
        minDate: new Date(),
        maxDate: (() => {
            let d = new Date()
            d.setDate(d.getDate() + 14)
            return d
        })(),
        //Warning: This will need changing if used on other areas of the site in the future
        container: document.querySelector("#bookMeetingModal"),
        onRenderCell({ date, cellType }) {
            if (cellType === "day") {
                const day = date.getDay()
                //0 = sunday, 6 = saturday
                if (day === 0 || day === 6) {
                    return {
                        disabled: true
                    }
                }
            }
            return {}
        }
    })
}